import PropTypes from "prop-types";
import React from "react";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import TouchBackend from "react-dnd-touch-backend";
import HTML5 from "react-dnd-html5-backend";
import withScrolling, {
  createHorizontalStrength,
  createVerticalStrength,
} from "react-dnd-scrollzone";

import { AssetTile, HtmlDragDropContext } from "signoxe/components";
import { Box } from "signoxe/components/layout";
import { AssetPropType } from "signoxe/constants/propTypes";
import { isAssetEditable, showIconForAsset } from "signoxe/utils/assets";
import AssetTileDND from "signoxe/components/AssetTileDND";
import CampaignTileView from "../CampaignTileView";

import "./styles.scss";

const ScrollingComponent = withScrolling("div");

const AssetTileView = ({
  assets,
  selection,
  onAssetChange,
  onAssetDelete,
  onAssetClick,
  onDrop,
  onView,
  isCampaignView,
  selectedCampaign,
  onRemove,
  campaigns,
  checkUnused,
  isMakerChecker
}) => (
  <Box wrap className="asset-tile-view" direction="row">
    <ScrollingComponent>
      {isCampaignView &&
        selectedCampaign &&
        selectedCampaign.assets.length === 0 && (
          <p>No assets yet in {selectedCampaign.name}</p>
        )}

      {isCampaignView &&
        selectedCampaign &&
        selectedCampaign.assets.map((item) => (
          <AssetTile
            key={item.id}
            asset={item}
            editable={isAssetEditable(item)}
            showIcon={showIconForAsset(item)}
            selected={selection && !!selection[item.id]}
            onChange={onAssetChange}
            onClick={onAssetClick}
            onClickDelete={onAssetDelete}
            isCampaignView={isCampaignView}
            campaign={selectedCampaign}
            onRemove={onRemove}
            folders={campaigns}
            isChecked={checkUnused}
            isMakerChecker={isMakerChecker}
          />
        ))}

      {!isCampaignView && (
        <>
          <CampaignTileView
            onDrop={onDrop}
            onView={onView}
            campaigns={campaigns}
          />
          {assets.map((item) => (
            <AssetTileDND asset={item}>
              <AssetTile
                key={item.id}
                asset={item}
                editable={isAssetEditable(item)}
                showIcon={showIconForAsset(item)}
                selected={selection && !!selection[item.id]}
                onChange={onAssetChange}
                onClick={onAssetClick}
                onClickDelete={onAssetDelete}
                folders={campaigns}
                isChecked={checkUnused}
                isMakerChecker={isMakerChecker}
              />
            </AssetTileDND>
          ))}
        </>
        // </HtmlDragDropContext>
      )}
    </ScrollingComponent>
  </Box>
);

AssetTileView.propTypes = {
  assets: PropTypes.arrayOf(AssetPropType),
  selection: PropTypes.object,
  onAssetChange: PropTypes.func,
  onAssetClick: PropTypes.func,
  onAssetDelete: PropTypes.func,
};

let backend = HTML5Backend;

if (window.innerWidth <= "600") {
  backend = TouchBackend;
}

console.log("Backend is ", backend);

export default AssetTileView;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetTileView/index.js